export const PAGE_NOT_FOUND = '/promo/promoLandingTemplate.jsp?promoLandingId=pagenotfound';
export const CONFIRMATION_ROUTE = '/confirmation';
export const MINOR_VERIFY_ROUTE = '/minor-verification';
export const FLOW_ERROR_ROUTE = '/flow-error';
export const NBA_ROUTE = '/success';
export const CONSENT_ERROR_ROUTE = '/consent-caregiver/error';
export const PERSONAL_INFO_LOOKUP_FORM = '/account-lookup/personal-info?flow=caregiving_access';
export const RX_LABEL_LOOKUP_FORM = '/account-lookup/rxlabel?flow=caregiving_access';
export const PET_LOOKUP_QUERY = '&petLookup=true';
export const VERIFY_LOOKUP_FORM = '/account-lookup/rxlabel?flow=caregiving_access&minorVerify=true';
export const ENT_PERSONAL_INFO_LOOKUP_FORM = '/account-lookup/personal-info?flow=ent_caregiving_access';
export const ENT_RX_LABEL_LOOKUP_FORM = '/account-lookup/rxlabel?flow=ent_caregiving_access';
export const ENT_VERIFY_LOOKUP_FORM = '/account-lookup/rxlabel?flow=ent_caregiving_access&minorVerify=true';
export const MANAGE_ROUTE = '/manage-person';
export const MINOR_VERIFY_OTP = '/otp';
export const MINOR_VERIFY_OTP_LOCKED = '/minor-verification/locked';
export const VIEW_ROUTE = '/view-caregiver';
export const CONTACT_ROUTE = '/view-contact';
export const CONSENT_ROUTE = '/consent-caregiver';
export const ERROR_ROUTE = '/api-error';
export const ERROR_PAGE_ROUTE = '/lookup-error';
export const PHARMACY_ROUTE = '/pharmacy/dashboard';
export const MGM_DB = '/account/manage-family';
export const SEND_INV = '/invite-caregiver';
export const HEALTHY_CAREGIVER = '/healthy-caregiver';
export const IDENTITY_INFO_LOOKUP = '/account-lookup/identity-info';
export const ONBOARDING_TIE_URL = '/account/onboarding/tie';
export const ENT_CG_FLOW_NAME = 'ent_caregiving_access';
export const PEOPLE_FOUND_SCREEN_DATA_COUNT = 5;
export const PEOPLE_FOUND_ROUTE = '/people-found';
export const VERIFY_DOB_ROUTE = '/verify-dob';
export const PEOPLE_CONNECT_FLOW = 'connect_people';
export const PEOPLE_CONNECT_SELF_SOURCE = 'CG';
export const sourceSystemsForCMKConnections = ["RXC","EPIC","PBM"];
export const CMK_CAREGIVEES_FLOW_NAME = 'CMK_FAMILY_MEMBERS';
export const POTENTIAL_CAREGIVEES_FLOW_NAME = 'POTENTIAL_CAREGIVEES';

// User types for query parameters
export const USER_TYPE_CMK_SPL = 'cmk-spl';

// Contact status values for query parameters
export const CONTACT_STATUS_MISSING = 'missing';
export const CONTACT_STATUS_AVAILABLE = 'available';

// Exit navigation query params
export const QUERY_EXIT_TYPE = 'exitType';
export const QUERY_REMAINING_CAREGIVEES = 'remainingPotentialCaregivees';
export const EXIT_TYPE_ABORT = 'maybeLater';
export const EXIT_TYPE_END_OF_FLOW = 'endOfFlow';
export const EXIT_TYPE_CLOSE = 'close';

// Entry point query param — identifies where the people-connect flow was initiated
export const QUERY_ENTRY_POINT = 'source';
export const QUERY_SSK = 'ssk';

